<div #formContainer class="form-container">
    @if (formGroup) {
        <form [formGroup]="formGroup">
            <clickatell-expansion-panel>
                <ng-container header>
                    <mat-panel-title>
                        Parameters
                    </mat-panel-title>
                </ng-container>
                <ng-container body>

                    <mat-select #channelMode [multiple]="false" [FormInput]="'Channel'" class="control-mat-select"
                                activeForm [activeForm]="formGroup" id="channelMode"
                                [formControlName]="'channelID'">
                        <mat-select-trigger>
                            @if (channelMode.value) {
                                <img src="assets/img/channel/{{channelMode.value}}.svg" width="24px"
                                     style="vertical-align: middle; margin-right: 8px;">
                                {{ channelMode.value | channelName }}
                            }
                        </mat-select-trigger>
                        @for (id of CHANNELS_SUPPORTED; track id) {
                            <mat-option [value]="id">
                                <img src="assets/img/channel/{{id}}.svg" width="24px"
                                     style="vertical-align: middle; margin-right: 8px;">
                                {{ id | channelName }}
                            </mat-option>
                        }
                    </mat-select>

                    <input [FormInput]="'Name'" class="control-input" activeForm [activeForm]="formGroup"
                           [formControlName]="'name'" placeholder="Enter a name" [attr.name]="'name'"/>

                    <input [FormInput]="'Description'" class="control-input" activeForm [activeForm]="formGroup"
                           id="description"
                           [formControlName]="'description'" placeholder="Enter a description"
                           [attr.name]="'description'"/>

                    @if (channelMode.value === RCS) {

                        <div class="control-div">
                            <mat-button-toggle-group #mediaToggle="matButtonToggleGroup" [value]="selectedMediaType"
                                                     class="control-input select_spacer media_toggle_group"
                                                     multiple="false"
                                                     (change)="mediaTypeChange(mediaToggle)"
                                                     hideSingleSelectionIndicator>
                                <mat-button-toggle class="selector-button" value="assets">Assets</mat-button-toggle>
                                <mat-button-toggle class="selector-button" value="variable">Variable</mat-button-toggle>
                            </mat-button-toggle-group>
                        </div>


                        <div class="control-div">

                            <div class="control-label-container">
                                <label class="control-label"> Add Media <span
                                        class="rcs-only">(RCS only)</span></label>
                            </div>
                            <clickatell-form-validation [controlName]="'imageRef'"
                                                        [form]="formGroup"></clickatell-form-validation>
                            @if (mediaToggle.value == 'assets') {
                                <input #imageRef [formControlName]="'imageRef'" hidden [attr.name]="'imageRef'">
                                <select-media [image]="imageRef.value" [imageOnly]="false" [menuHeader]="true"
                                              (setImageRef)="setImage($event)">
                                </select-media>
                            } @else {
                                <input class="control-input select_spacer"
                                       activeForm [activeForm]="formGroup"
                                       id="imageRef"
                                       [formControlName]="'imageRef'"
                                       placeholder="Enter a variable" style="resize: none"
                                       (change)="mediaValidation()"/>
                            }
                        </div>
                    }

                    <input [FormInput]="'Send To (MSISDN)'" class="control-input" activeForm
                           [activeForm]="formGroup"
                           [formControlName]="'sendTo'" placeholder="Enter MSISDN" [attr.name]="'sendTo'"/>

                    <input [FormInput]="'Reference ID'" [optionalLabel]="'Optional'" class="control-input" activeForm
                           [activeForm]="formGroup"
                           [formControlName]="'referenceId'" placeholder="Enter a reference ID"
                           [attr.name]="'referenceId'"/>

                    <input [FormInput]="'Integration'" class="control-input" activeForm [activeForm]="formGroup"
                           [formControlName]="'integrationId'" placeholder="Enter a Integration ID"
                           [attr.name]="'integrationId'"/>


                    <input [FormInput]="'API Key'" class="control-input" activeForm [activeForm]="formGroup"
                           [formControlName]="'apiKey'" placeholder="Enter a Api key"
                           [attr.name]="'apiKey'"/>

                    <input [FormInput]="'Header'" [optionalLabel]="'Optional'" class="control-input" activeForm
                           [activeForm]="formGroup"
                           id="header"
                           [formControlName]="'header'" placeholder="Enter a header"
                           [attr.name]="'header'"/>

                    <div class="text-area-container">
                        <textarea #bodyText [FormInput]="'Body Text'" class="control-textArea"
                                  activeForm [activeForm]="formGroup" id="bodyText"
                                  [formControlName]="'bodyText'" placeholder="Enter body text"
                                  [attr.name]="'bodyText'"
                        ></textarea>
                        <div class="char-count"
                             [class.count-error]="bodyText.value.length > CHANNEL_LIMITS[channelMode.value] && channelMode.value === SMS">
                            {{ bodyText.value.length }} / {{ CHANNEL_LIMITS[channelMode.value] }} characters
                        </div>
                    </div>

                    @if (bodyText.value.length > CHANNEL_LIMITS[channelMode.value] && channelMode.value === SMS) {
                        <ng-template [ngTemplateOutlet]="templateStatus"
                                     [ngTemplateOutletContext]="{ message: SMS_WARNING_MESSAGE, type: 'warn' }"></ng-template>
                    }

                    <div class="control-div toggle-field">
                        <div class="label-left-block">
                            <label class="control-label"> End Session </label>
                        </div>
                        <div class="toggle-btn">
                            <mat-slide-toggle #endSession [color]="'primary'" class="control-toggle"
                                              [formControlName]="'endSession'">
                            </mat-slide-toggle>
                        </div>
                    </div>

                </ng-container>
            </clickatell-expansion-panel>

            <clickatell-expansion-panel>
                <ng-container header>
                    <mat-panel-title>
                        Next Step
                    </mat-panel-title>
                </ng-container>
                <ng-container body>
                    @if (!endSession.checked) {
                        <div class="control-div logic-div">
                            <div class="logic-item-title logic-item-success">Success</div>
                            <ng-container
                                    *ngTemplateOutlet="next; context: { controlName: 'success', form: formGroup}">
                            </ng-container>
                        </div>
                    }

                    <div class="control-div logic-div">
                        <div class="logic-item-title logic-item-error">Error</div>
                        <ng-container
                                *ngTemplateOutlet="next; context: { controlName: 'error', form: formGroup}">
                        </ng-container>
                    </div>
                </ng-container>
            </clickatell-expansion-panel>

            <clickatell-expansion-panel>
                <ng-container header>
                    <mat-panel-title>
                        Menu Items
                    </mat-panel-title>
                </ng-container>
                <ng-container body>

                    <ng-container *ngTemplateOutlet="options"></ng-container>
                    <div class="control-add-button">
                        <button [disabled]="!canEdit" (click)="addOption()">
                            Add New Option
                        </button>
                    </div>

                </ng-container>
            </clickatell-expansion-panel>
        </form>
    }
</div>

<ng-template #options>
    @if (formGroup.controls.items; as optionsList) {
        <ng-container [formGroup]="formGroup">
            <div class="add-new-item-block">
                @if (optionsList.controls.length >= 1) {
                    <div (click)="addOption()" class="addText">
                        <span class="control-label-add-btn-icon">
                          <img class="action-img" src='./assets/svg/addIcon.svg'/>
                        </span>
                        <span class="control-label-add-btn-label">Add New Item</span>
                    </div>

                    <div class="collapse-expand-btn"
                         [ngClass]="{ collapsed: collapseExpandStates === 'open' }"
                         (click)="collapseExpandLogic(LogicAccordion)"
                         [matTooltip]="collapseExpandTooltip" matTooltipHideDelay="200"
                         matTooltipClass="left-tooltip"></div>
                }
            </div>
            <mat-accordion cdkDropList class="accordion-container" [multi]="true" #LogicAccordion="matAccordion"
                           (cdkDropListDropped)="drop($event, LogicAccordion)">
                @for (option of optionsList.controls; track option; let index = $index) {
                    <mat-expansion-panel [expanded]="true" cdkDrag>
                        <div class="custom-placeholder" *cdkDragPlaceholder></div>
                        <div *cdkDragPreview class="logic-result-header dragging">
                            <div class="logic-result-header-title">
                                @if (text.value.length > 0) {
                                    {{ index + 1 }}. {{ text.value }}
                                } @else {
                                    <span class="control-result-defaultTitle">{{ index + 1 }}. [Option Text]</span>
                                }
                            </div>
                        </div>
                        <mat-expansion-panel-header class="logic-result-header">
                            <div>
                                @if (text.value.length > 0) {
                                    {{ index + 1 }}. {{ text.value }}
                                } @else {
                                    <span class="control-result-defaultTitle">{{ index + 1 }}. [Option Text]</span>
                                }
                            </div>
                            <div class="logic-result-header-btn">
                                <div class="move-btn" cdkDragHandle></div>
                                <button class="control-result-delete" [disabled]="!canEdit.canEditFlows"
                                        (click)="deleteOption(index, $event)">
                                    <img class="control-result-delete-btn" src="./assets/svg/redesign/trash.svg">
                                </button>
                            </div>
                        </mat-expansion-panel-header>
                        <div class="logic-result-container" [formGroup]="option">

                            <input #text [FormInput]="'Item Name'" class="control-input" activeForm
                                   [activeForm]="option"
                                   [id]="'text-' + index + 1"
                                   [formControlName]="'text'" placeholder="Add item name"
                                   [attr.name]="'text'"/>

                            <textarea [FormInput]="'Additional Parameter'" class="control-textArea"
                                      activeForm
                                      [activeForm]="option"
                                      [id]="'additionalData-' + index + 1"
                                      [formControlName]="'additionalData'" placeholder="Add additional data"
                                      [attr.name]="'additionalData'"
                                      [optionalLabel]="'Optional'"
                            ></textarea>

                            <div class="control-result-container">
                                <div class="control-div">
                                    <label class="control-label">
                                        <span class="pont-to">Point To</span>
                                        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
                                    </label>
                                    @if (nodeFlowDetails) {
                                        <next-selector [canEditFlows]="canEdit.canEditFlows"
                                                       [selectorType]="'both'"
                                                       [flowSteps]="nodeFlowDetails.currentFlowSteps"
                                                       [flows]="nodeFlowDetails.flows"
                                                       [name]="'next'"
                                                       [form]="option"
                                                       [stepId]="nodeFlowDetails.stepId">
                                        </next-selector>
                                    }
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                }
            </mat-accordion>
        </ng-container>
        @if (optionsList.controls.length >= 5 && formGroup.controls.channelID.value === RCS) {
            <ng-template [ngTemplateOutlet]="templateStatus"
                         [ngTemplateOutletContext]="{ message: BUTTON_TOOLTIP_MESSAGE, type: 'error' }"></ng-template>
        }
        @if (showButtonErrorMessage && optionsList.controls.length === 0) {
            <ng-template [ngTemplateOutlet]="templateStatus"
                         [ngTemplateOutletContext]="{ message: BUTTON_REQUIRED_MESSAGE, type: 'error' }"></ng-template>
        }
    }
</ng-template>


<ng-template #templateStatus let-message="message" let-type="type">
    <div class="banner-container">
        <div class="banner-block banner-{{type}}-block">
            <div class="icon icon-{{type}} "></div>
            <div class="content">
                <span>{{ message }}</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #next let-controlName="controlName" let-form="form">
    <label class="point-to-label">
        Go To
        <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
    </label>
    @if (nodeFlowDetails) {
        <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
                       [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
                       [name]="controlName"
                       [form]="form"
                       [stepId]="nodeFlowDetails.stepId">
            >
        </next-selector>
    }
</ng-template>